import { useEffect, useState } from "react";
import customAxios from "../../../../utils/customAxios";
import setAuthToken from "../../../../utils/setAuthToken";
import { mapRequestToRow } from "../utils";

const useModificationRequests = (params) => {
  const [data, setData] = useState([]);
  const [isLoadingRows, setIsLoadingRows] = useState(false);
  const [requestError, setRequestError] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchRequests = async () => {
        // params.refreshKey is an optional incrementing counter used to force re-fetch
        setIsLoadingRows(true);
        setRequestError("");

        try {
          if (localStorage.token) {
            setAuthToken(localStorage.token);
          }

          // Build query string from params
          const query = new URLSearchParams({
            sortBy: params.sortBy || 'asc',
            search: params.search || '',
            page: params.page || 1,
            limit: params.limit || 10,
            orderBy: params.orderBy || '_id',
            disableCalculateTotal: true,
            draw: params.draw || 0,
            id: params.id || '',
            startDate: params.startDate || '',
            endDate: params.endDate || '',
            status: params.status?.value || '',
            userType: params.userType?.value || '',
            responseBy: params.responseBy?.value || '',
          }).toString();

          const response = await customAxios.get(`/api/admin/request-change-booking?${query}`);
          const responseData = response?.data?.data || {};
          const responseRows = responseData.data || [];
          setData(responseRows[0]);
        } catch (error) {
          setData([]);
        } finally {
          setIsLoadingRows(false);
        }
      };

      fetchRequests();
    }, 500);

    return () => clearTimeout(timer);
  }, [
    params.sortBy,
    params.search,
    params.page,
    params.limit,
    params.orderBy,
    params.disableCalculateTotal,
    params.draw,
    params.id,
    params.startDate,
    params.endDate,
    params.status,
    params.userType,
    params.responseBy,
    params.requestType,
    params.refreshKey,
  ]);

  return {
    data,
    isLoadingRows,
    requestError
  };
};

export default useModificationRequests;
